
export function toValue(model, val) {
  const value = val || {};
  value.year = model.getFullYear();
  value.month = model.getMonth() + 1;
  value.date = model.getDate();
  value.hours = model.getHours();
  value.minute = model.getMinutes();
  value.second = model.getSeconds();
  return value;
}

export function toModel(o) {
  return new Date(`${o.year}/${o.month}/${o.date} ${o.hours}:${o.minute}:${o.second}`);
}